import snakecaseKeys from 'snakecase-keys';
import { InjectiveExchangeV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgAuthorizeStakeGrants extends MsgBase {
    static fromJSON(params) {
        return new MsgAuthorizeStakeGrants(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectiveExchangeV1Beta1Tx.MsgAuthorizeStakeGrants.create();
        message.sender = params.injectiveAddress;
        message.grants = [
            {
                grantee: params.grantee,
                amount: params.amount,
            },
        ];
        return InjectiveExchangeV1Beta1Tx.MsgAuthorizeStakeGrants.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.exchange.v1beta1.MsgAuthorizeStakeGrants',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'exchange/MsgAuthorizeStakeGrants',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.exchange.v1beta1.MsgAuthorizeStakeGrants',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.exchange.v1beta1.MsgAuthorizeStakeGrants',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveExchangeV1Beta1Tx.MsgAuthorizeStakeGrants.encode(this.toProto()).finish();
    }
}
